export enum FilterValueMode {
  ALL = 'ALL',
  NULL = 'NULL',
  NOT_NULL = 'NOT_NULL',
  ERROR = 'ERROR'
}

export enum FilterValueLangMode {
  ALL = 'ALL',
  EN = 'EN',
  NOT_EN = 'NOT_EN',
  NOT_EN_TR = 'NOT_EN_TR'
}

export enum FilterBoolean {
  ALL = 'ALL',
  TRUE = 'TRUE',
  FALSE = 'FALSE'
}

export enum FilterArticleMode {
  RESEARCHER = 'RESEARCHER',
  LIBRARY = 'LIBRARY'
}

export enum FilterDlgStatus {
  ALL = 'ALL',
  TO_DO = 'TO_DO',
  DONE = 'DONE'
}
